import { styled } from 'styled-components';

export const ErrorMessageWrapper = styled.span`
  font: var(--font-body-small--regular);
  color: var(--color-numa-red--100);
`;
